var User = (function () {
    const ACCESS_TOKEN_KEY = 'access_token'
    const ACCESS_EXPIRATION_TIME = 'access_expiration_time'
    const ACCESS_USER_NAME = 'access_user_name'
    const ACCESS_USER_MAIL = 'access_user_mail'
    const IS_ADMIN = 'is_admin'
    const MEMBER_ROLE = 'member_role'
    const ADMIN_ROLE = 'admin_role'
    const SECRETARY_MANAGEMENT_ROLE = 'secretary_management_role'
    const SECRETARY_VIEW_ROLE = 'secretary_view_role'
    // TODO: const ACCESS_FIRST_NAME = 'access_firstname'

    var getToken = () => {
        return localStorage.getItem(ACCESS_TOKEN_KEY)
    }

    var setToken = (newToken, newExpiration, user, mail) => {
        localStorage.setItem(ACCESS_TOKEN_KEY, newToken)
        localStorage.setItem(ACCESS_EXPIRATION_TIME, newExpiration)
        localStorage.setItem(ACCESS_USER_NAME, user)
        localStorage.setItem(ACCESS_USER_MAIL, mail)
    }

    var getExpiration = () => {
        return localStorage.getItem(ACCESS_EXPIRATION_TIME)
    }
    var getUsername = () => {
        return localStorage.getItem(ACCESS_USER_NAME)
    }
    var getMail = () => {
        return localStorage.getItem(ACCESS_USER_MAIL)
    }
    //TODO:     var getFirstname = function () {
    //              return localStorage.getItem(ACCESS_FIRST_NAME);
    //          };

    var removeToken = () => {
        localStorage.removeItem(ACCESS_TOKEN_KEY)
        localStorage.removeItem(ACCESS_EXPIRATION_TIME)
        localStorage.removeItem(ACCESS_USER_NAME)
        localStorage.removeItem(ACCESS_USER_MAIL)
        localStorage.removeItem(MEMBER_ROLE)
        localStorage.removeItem(ADMIN_ROLE)
        localStorage.removeItem(SECRETARY_MANAGEMENT_ROLE)
        localStorage.removeItem(SECRETARY_VIEW_ROLE)
        localStorage.removeItem(IS_ADMIN)

    }

    var setIsAdmin = (isAdmin) => {
        localStorage.setItem(IS_ADMIN, isAdmin)
    }

    var isAdmin = () => {
        return localStorage.getItem(IS_ADMIN) === 'true'
    }

    var setRoles = (roles) => {
        localStorage.setItem(MEMBER_ROLE, roles.memberRole)
        localStorage.setItem(ADMIN_ROLE, roles.adminRole)
        localStorage.setItem(SECRETARY_MANAGEMENT_ROLE, roles.secretaryManagementRole)
        localStorage.setItem(SECRETARY_VIEW_ROLE, roles.secretaryViewRole)
    }

    var hasMemberRole = () => {
        return localStorage.getItem(MEMBER_ROLE) === 'true'
    }

    var hasAdminRole = () => {
        return localStorage.getItem(ADMIN_ROLE)
    }

    var hasSecretaryManagementRole = () => {
        return localStorage.getItem(SECRETARY_MANAGEMENT_ROLE)
    }

    var hasSecretaryViewRole = () => {
        return localStorage.getItem(SECRETARY_VIEW_ROLE)
    }

    var hasRole = (role) => {
        switch (role) {
            case MEMBER_ROLE:
                return localStorage.getItem(MEMBER_ROLE)
            case ADMIN_ROLE:
                return localStorage.getItem(ADMIN_ROLE)
            case SECRETARY_MANAGEMENT_ROLE:
                return localStorage.getItem(SECRETARY_MANAGEMENT_ROLE)
            case SECRETARY_VIEW_ROLE:
                return localStorage.getItem(SECRETARY_VIEW_ROLE)
            default:
                return false
        }
    }

    var isLoggedIn = () => {
        const idToken = getToken()
        var logged = !!idToken && !isTokenExpired(idToken)
        if (!logged) {
            removeToken()
        }
        return logged
    }

    var getTokenExpirationDate = () => {
        return new Date(getExpiration())
    }

    var isTokenExpired = (token) => {
        const expirationDate = getTokenExpirationDate(token)
        return expirationDate < new Date()
    }

    return {
        getToken: getToken,
        setToken: setToken,
        getUsername: getUsername,
        getMail: getMail,
        getExpiration: getExpiration,
        removeToken: removeToken,
        isLoggedIn: isLoggedIn,
        isAdmin: isAdmin,
        setIsAdmin: setIsAdmin,
        hasMemberRole: hasMemberRole,
        hasAdminRole: hasAdminRole,
        hasSecretaryManagementRole: hasSecretaryManagementRole,
        hasSecretaryViewRole: hasSecretaryViewRole,
        hasRole: hasRole,
        setRoles: setRoles
    }
})()

export default User;


// WEBPACK FOOTER //
// ./src/components/Global/Modules/User.js